document.addEventListener('DOMContentLoaded', function () {
  const TAB_KEY = 'pdp_swatch_tab';
  const TAB_TTL = 30 * 60 * 1000;
  const SIZE_MISS_KEY = 'pdp_size_miss';

  function getSelectedSize() {
    var checkedInput = document.querySelector('input[name="option2"]:checked');
    if (!checkedInput) checkedInput = document.querySelector('input[name="option1"]:checked');
    if (!checkedInput) return null;
    var label = document.querySelector('label[for="' + checkedInput.id + '"]');
    if (!label) return null;
    return label.textContent.trim();
}

  function getSelectedTog() {
    var hasOption2 = document.querySelector('input[name="option2"]');
    if (!hasOption2) return null;
    var checkedInput = document.querySelector('input[name="option1"]:checked');
    if (!checkedInput) return null;
    var label = document.querySelector('label[for="' + checkedInput.id + '"]');
    if (!label) return null;
    return label.textContent.trim();
}

  function getActiveTabName() {
    var tab = document.querySelector('.swatch-collections-tab[aria-expanded="true"], .swatch-collections-tab.active');
    return tab ? tab.textContent.trim() : null;
  }

  function saveTabState() {
    var tab = getActiveTabName();
    if (!tab) return;
    sessionStorage.setItem(TAB_KEY, JSON.stringify({
      tab: tab,
      savedAt: Date.now()
    }));
  }

  function getSavedTab() {
    var raw = sessionStorage.getItem(TAB_KEY);
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!data.savedAt || !data.tab) {
        sessionStorage.removeItem(TAB_KEY);
        return null;
      }
      if (Date.now() - data.savedAt > TAB_TTL) {
        sessionStorage.removeItem(TAB_KEY);
        return null;
      }
      return data.tab;
    } catch (e) {
      sessionStorage.removeItem(TAB_KEY);
      return null;
    }
  }

  function restoreTab(tabName) {
    if (!tabName) return;
    var tabs = document.querySelectorAll('.swatch-collections-tab');
    for (var i = 0; i < tabs.length; i++) {
      var text = tabs[i].textContent.trim().toLowerCase();
      if (text !== tabName.toLowerCase()) continue;
      var isActive =
        tabs[i].getAttribute('aria-expanded') === 'true' ||
        tabs[i].classList.contains('active');
      if (!isActive) tabs[i].click();
      break;
    }
  }

  function bindTabs() {
    var tabs = document.querySelectorAll('.swatch-collections-tab');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].dataset.tabBound === '1') continue;
      tabs[i].dataset.tabBound = '1';
      tabs[i].addEventListener('click', function () {
        setTimeout(function () { saveTabState(); }, 0);
      });
    }
  }

  function getHandleFromUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      var parts = u.pathname.split('/products/');
      if (!parts[1]) return null;
      return parts[1].replace(/^\/+|\/+$/g, '');
    } catch (e) {
      return null;
    }
  }

  function normalizeSize(str) {
    return str ? str.trim().toLowerCase() : '';
  }

 function findTargetVariant(productData, currentTog, currentSize) {
  if (!productData || !productData.variants || !productData.variants.length) return null;
  var variants = productData.variants;
  var size = normalizeSize(currentSize);
  var tog = normalizeSize(currentTog);

  if (tog && size) {
    for (var i = 0; i < variants.length; i++) {
      if (normalizeSize(variants[i].option1) === tog && normalizeSize(variants[i].option2) === size) {
        return variants[i];
      }
    }
  }

  if (size) {
    for (var j = 0; j < variants.length; j++) {
      if (normalizeSize(variants[j].option1) === size) return variants[j];
    }
  }

  if (size) {
    for (var k = 0; k < variants.length; k++) {
      if (normalizeSize(variants[k].option2) === size) return variants[k];
    }
  }

  return variants[0] || null;
}

  function waitForContainer(callback) {
    var container = document.querySelector('.swatch-collections-tabs-container');
    if (container) {
      callback(container);
      return;
    }
    var observer = new MutationObserver(function () {
      var container = document.querySelector('.swatch-collections-tabs-container');
      if (container) {
        observer.disconnect();
        callback(container);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

    function showUnavailableMessage(colorName, sizeName) {
    var existing = document.querySelector('.size-unavailable-message');
    if (existing) existing.remove();

    var template = (window.swatchMessages && window.swatchMessages.sizeUnavailable)
      ? window.swatchMessages.sizeUnavailable
      : 'The Color [COLOR] and Size [SIZE] is not available, please check your selected options';

    var parts = template.split(/(\[COLOR\]|\[SIZE\])/);
    var html = parts.map(function(part) {
      if (part === '[COLOR]') return '<strong>' + colorName + '</strong>';
      if (part === '[SIZE]') return '<strong>' + sizeName + '</strong>';
      return part;
    }).join('');

    var msg = document.createElement('div');
    msg.className = 'size-unavailable-message';
    msg.innerHTML = html;

    waitForContainer(function (container) {
      container.parentNode.insertBefore(msg, container);
      setTimeout(function () {
        // if (msg.parentNode) msg.remove();
      }, 5000);
    });
  }

  function checkSizeMiss() {
    var raw = sessionStorage.getItem(SIZE_MISS_KEY);
    if (!raw) return;
    sessionStorage.removeItem(SIZE_MISS_KEY);
    try {
      var data = JSON.parse(raw);
      if (data.prevSize && data.prevColor) {
        showUnavailableMessage(data.prevColor, data.prevSize);
      }
    } catch (e) {}
  }

  function restoreVariantFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return;
    var productVariantElement = document.querySelector('product-variants');
    if (!productVariantElement) return;
    productVariantElement.selectVariant(parseInt(variantId, 10));
  }

  function goToSwatch(link) {
    var href = link.getAttribute('href');
    if (!href) return;

    var handle = getHandleFromUrl(href);
    if (!handle) {
      window.location.href = href;
      return;
    }

    var currentSize = getSelectedSize();
    var currentTog = getSelectedTog();

    saveTabState();

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (productData) {
        var variant = findTargetVariant(productData, currentTog, currentSize);
        var sizeMatched = variant && currentSize && (
          normalizeSize(variant.option1) === normalizeSize(currentSize) ||
          normalizeSize(variant.option2) === normalizeSize(currentSize)
        );

        if (!sizeMatched && currentSize) {
          var titleParts = (productData.title || '').split(' - ');
          var colorName = titleParts[1] || productData.title || '';
          sessionStorage.setItem(SIZE_MISS_KEY, JSON.stringify({
            prevSize: currentSize,
            prevColor: colorName
          }));
        } else {
          sessionStorage.removeItem(SIZE_MISS_KEY);
        }

        if (variant && variant.id) {
          window.location.href = '/products/' + handle + '?variant=' + variant.id;
          return;
        }

        window.location.href = href;
      })
      .catch(function () {
        window.location.href = href;
      });
  }

  function bindSwatches() {
    function attachToLinks() {
      var links = document.querySelectorAll('.color-swatch-cross-link');
console.log('total:', links.length);
if (links[0]) {
  console.log('dataset:', JSON.stringify(links[0].dataset));
}
console.log('SIZE_MISS:', sessionStorage.getItem('pdp_size_miss'));
      for (var i = 0; i < links.length; i++) {
        if (links[i].dataset.swatchBound === '1') continue;
        links[i].dataset.swatchBound = '1';
        links[i].addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          goToSwatch(this);
        }, true);
      }
    }

    attachToLinks();

    var observer = new MutationObserver(function () {
      attachToLinks();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function restoreAll() {
    checkSizeMiss();

    var savedTab = getSavedTab();
    if (savedTab) {
      setTimeout(function () { restoreTab(savedTab); }, 100);
    }

    setTimeout(function () { restoreVariantFromUrl(); }, 200);
  }

  bindTabs();
  bindSwatches();
  restoreAll();
});